import { some, map } from 'lodash';
export function validateAll(fields) {
    return !some(map(fields, function (field) { return !field.validate(); }));
}
//# sourceMappingURL=validateAll.js.map